import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
// Import API config early to setup axios interceptors globally
import "@/config/api";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('CraftFlow Pro: Service Worker registered successfully', registration.scope);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content available, notify user
              console.log('CraftFlow Pro: New version available! Refresh to update.');
            }
          });
        });
      })
      .catch((error) => {
        console.log('CraftFlow Pro: Service Worker registration failed', error);
      });
  });
}
